
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Hero from "../components/HomePage/Hero";
import TrustedCompanies from "../shared/TrustedCompanies";
import CoreFeatures from "../components/HomePage/CoreFeatures";
import LiveDemoForm from "../components/HomePage/LiveDemoForm";
import UseCases from "../components/HomePage/UseCases";
import HowItWorks from "../components/HomePage/HowItWorks";
import Testimonials from "../shared/Testimonials";
import FAQ from "../components/HomePage/FAQ";
import Footer from "../shared/Footer";
import OurAgents from "../components/HomePage/OurAgents"
import Navbar from "../shared/Navbar";

function Home(){
	const location = useLocation();

useEffect(() => {
  if (location.state?.scrollTo) {
    const section = document.getElementById(location.state.scrollTo);

    if (section) {
      setTimeout(() => {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }
}, [location]);
	return(
		<div>
	  <Navbar />
			<Hero/>
			 <TrustedCompanies/>
             <OurAgents/>
			<CoreFeatures/>
			<LiveDemoForm/>
			<UseCases/>
			<HowItWorks/>
			<Testimonials/>
			<FAQ/>
			<Footer/> 
		</div>
	);
}

export default Home;